import { ReactElement, ReactNode } from 'react';
import { Global } from '@emotion/react';
import { ModalProps } from 'antd';
import { Modal } from 'common/components/antd/Modal/Modal';
import {
  globalEnhancedModalStyles,
  SHeader,
  STitle,
  SBody,
  SFooter,
} from './EnhancedModal.styles';

export type EnhancedModalProps = Omit<ModalProps, 'footer' | 'closable'> & {
  children: ReactNode;
};

export const Header = ({ children }: { children: ReactNode }): ReactElement => (
  <SHeader>
    <STitle>{children}</STitle>
  </SHeader>
);

export const Body = ({ children }: { children: ReactNode }): ReactElement => <SBody>{children}</SBody>;

export const Footer = (
  { children, showBorderTop = true }: { children: ReactNode; showBorderTop?: boolean }
): ReactElement => (
  <SFooter bt={showBorderTop}>{children}</SFooter>
);

export const EnhancedModal = ({ children, ...restProps }: EnhancedModalProps): ReactElement => (
  <div>
    <Global styles={globalEnhancedModalStyles} />
    <Modal wrapClassName="enhanced-modal" closable={false} footer={null} {...restProps}>
      {children}
    </Modal>
  </div>
);
